import { useRef, useEffect } from 'react';

import { useChatSearch } from '../ChatSearchContext';
import type { ChatSearchState } from '../types';

export const useSubscriptionManager = () => {
  const stateSubscribersRef = useRef<((state: ChatSearchState) => void)[]>([]);
  const { showResults, answers, isLoadingConversation, loadError } = useChatSearch();

  // Notify subscribers whenever the state changes
  useEffect(() => {
    const state: ChatSearchState = {
      showResults,
      answers,
      isLoading: isLoadingConversation,
      error: loadError,
    };

    stateSubscribersRef.current.forEach((callback) => callback(state));
  }, [showResults, answers, isLoadingConversation, loadError]);

  // Function to add a new subscriber
  const subscribeToStateChanges = (callback: (state: ChatSearchState) => void) => {
    stateSubscribersRef.current.push(callback);
    // Notify the new subscriber with the initial state
    callback({
      showResults,
      answers,
      isLoading: isLoadingConversation,
      error: loadError,
    });

    // Return an unsubscribe function
    return () => {
      stateSubscribersRef.current = stateSubscribersRef.current.filter((cb) => cb !== callback);
    };
  };

  return { subscribeToStateChanges };
};
